module.exports = {
  pathPrefix: '/',
  title: 'Florin Catalin | Product, Design, Engineering', // Navigation and Site Title
  titleAlt: 'Florin Catalin', // Title for JSONLD
  description: 'The personal website, portfolio, and blog of Florin Catalin.',
  headline:
    'Personal website, portfolio, and blog of UX/UI Engineer & Designer Florin Catalin.', // Headline for schema.org JSONLD
  url: 'https://www.florincatalin.com', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  logo: '/img/favicon-seo.png', // Used for SEO
  ogLanguage: 'en_US', // Facebook Language

  // JSONLD / Manifest
  favicon: 'src/favicon.png', // Used for manifest favicon generation
  shortName: 'F. Catalin', // shortname for manifest. MUST be shorter than 12 characters
  author: 'Florin Catalin', // Author for schemaORGJSONLD
  themeColor: '#ffffff',
  backgroundColor: '#ffffff',

  twitterUsername: '@heyflorin', // Twitter Username
  facebookAppId: '285210128750934' // Facebook App Id
}
